// extracted by mini-css-extract-plugin
export default {"loading":"loadingscreen_loading__vbEZz"};